/*
 * Copyright (c) Nexign, JSC, 2019.
 */

/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.1.0
 * @since 1.0.0
 */

import { gtmOperationPush } from './index';

/**
 * ------------------------------------
 *  LOAD OPERATIONS
 *  -----------------------------------
 */

/**
 * @description Call Operation on Login Success: Auth click submit button
 * @param {string} susrId ( login )
 * @param {string} clientTypeId ( role type)
 */
export const onLoginSuccessOperation = {
    'event': 'addEvents_makeActions',
    'event_id': 'd-v217-e1',
    'event_cat': 'Auth',
    'event_name': 'successAuth',
    'event_param': '(empty)',
};

/**
 * @description Call Operation on Login Error: Auth click submit button
 * @param {string} error Message
 */
export const onLoginErrorOperation = (error: string) => {
    gtmOperationPush({
        'event': 'addEvents_makeConversions',
        'event_id': 'd-v95-e6',
        'event_cat': 'Вход',
        'event_name': 'sendError1',
        'event_param': error,
    })
};

/**
 * @description Call Operation on Captcha Show: Auth click submit button with incorrect credentials
 */
export const onCaptchaShowOperation = () => {
    gtmOperationPush({
        'event': 'addEvents_makeConversions',
        'event_id': 'd-v95-e7',
        'event_cat': 'Вход',
        'event_name': 'viewInput1',
        'event_param': 'Капча',
    })
};

/**
 * ------------------------------------
 *  CLICK OPERATIONS
 *  -----------------------------------
 */

/**
 * @description Call Operation on Click ForgetPassword: Auth LoginPage
 */
export const onForgetPasswordClickOperation = () => {
    gtmOperationPush({
        'event': 'addEvents_useNavigations',
        'event_id': 'd-v95-e3',
        'event_cat': 'Вход',
        'event_name': 'clickElement',
        'event_param': 'Забыли пароль?',
    })
};

/**
 * @description Call Operation on Click GetAccess: Auth LoginPage Accordion
 */
export const onAccordionGetAccessClickOperation = () => {
    gtmOperationPush({
        'event': 'addEvents_makeActions',
        'event_id': 'd-v95-e4',
        'event_cat': 'Accordions',
        'event_name': 'openAccordion',
        'event_param': 'Как получить доступ?',
    })
};




